import { createAction } from "redux-actions";
import { moduleSlug as namespace } from "modules/Tracker/services/constants";

export const stopTrackAction = createAction(`${namespace}/STOP_TRACK`);
export const rescrapeTrackAction = createAction(`${namespace}/RESCRAPE_TRACK`);
export const resendScrapedResultsAction = createAction(`${namespace}/RESEND_SCRAPED_RESULTS`);

export const getViewResults = createAction(`${namespace}/GET_VIEW_RESULTS`);
export const setViewResultsDialog = createAction(`${namespace}/SET_VIEW_RESULTS_DIALOG`);
export const mergeViewResultsDialog = createAction(`${namespace}/MERGE_VIEW_RESULTS_DIALOG`);

export const getViewScrapeAttempts = createAction(`${namespace}/GET_VIEW_SCRAPE_ATTEMPTS`);
export const setViewScrapeAttemptsDialog = createAction(`${namespace}/SET_VIEW_SCRAPE_ATTEMPTS_DIALOG`);
export const mergeViewScrapeAttemptsDialog = createAction(`${namespace}/MERGE_VIEW_SCRAPE_ATTEMPTS_DIALOG`);

export const getViewMetadata = createAction(`${namespace}/GET_VIEW_METADATA`);

export const getSourceResults = createAction(`${namespace}/GET_SOURCE_RESULTS`);
export const setSourceResultsDialog = createAction(`${namespace}/SET_SOURCE_RESULTS_DIALOG`);
export const mergeSourceResultsDialog = createAction(`${namespace}/MERGE_SOURCE_RESULTS_DIALOG`);

export const setMetadata = createAction(`${namespace}/SET_METADATA`);

export const setBuffer = createAction(`${namespace}/SET_BUFFER`);

export const getStatusHistory = createAction(`${namespace}/GET_STATUS_HISTORY`);
export const setStatusHistoryDialog = createAction(`${namespace}/SET_STATUS_HISTORY_DIALOG`);
export const mergeStatusHistoryDialog = createAction(`${namespace}/MERGE_STATUS_HISTORY_DIALOG`);

export const getTrackerTree = createAction(`${namespace}/GET_TRACKER_TREE`);
export const setTrackTree = createAction(`${namespace}/SET_TRACKER_TREE`);
export const mergeTrackTree = createAction(`${namespace}/MERGE_TRACKER_TREE`);

export const exportResultObjects = createAction(`${namespace}/EXPORT_RESULT_OBJECTS`);
export const checkSourceTrack = createAction(`${namespace}/CHECK_SOURCE_TRACK`);
export const downloadHttpResponseContentToFile = createAction(`${namespace}/DOWNLOAD_HTTP_RESPONSE_CONTENT_TO_FILE`);

export const setDownloadResultObjectsDialog = createAction(`${namespace}/SET_DOWNLOAD_RESULT_OBJECTS_DIALOG`);
export const mergeDownloadResultObjectsDialog = createAction(`${namespace}/MERGE_DOWNLOAD_RESULT_OBJECTS_DIALOG`);
